import { css } from "styled-components";

export const HorizontalVerticalCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const JustifyContentCenter = css`
  display: flex;
  justify-content: center;
`;

export const AlignItemsCenter = css`
  display: flex;
  align-items: center;
`;
